<template>
    <div>
        <div class="loaded-content" v-if="isData">
            <slot></slot>
        </div>
        <div class="empty-content" v-if="noData && !isData">
            <slot name="empty">
                <div class="alert alert-info" role="alert">
                    No data in the database.
                </div>
            </slot>
        </div>
        <div class="loading-content" v-if="!noData && !isData">
            <slot name="loading">
                <div class="alert alert-info" role="alert">
                    <i class="fas fa-cog fa-spin"></i> Loading...
                </div>
            </slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            isData: {
                type: Boolean,
                default: true
            },
            timeout: {
                type: Number,
                default: 3000
            }
        },

        data() {
            return {
                noData: false,
            };
        },

        watch: {
            isData(newValue) {
                if (newValue) {
                    clearTimeout(this.noDataTimeout);
                }
            }
        },

        created() {
            this.noDataTimeout = setTimeout(() => {
                this.noData = true;
            }, this.timeout);
        }
    };
</script>
